<template>
  <div class="etx-container Container" :class="paragraphClassList">
    <div class="etx-center Center">
      <div class="etx-flex Flex mob-l:c-2 tab-l:c-3 gv-300 av-stretch">
        <div v-for="newsItem in News" class="etx-flex__item Flex__item">
          <div class="etx-card Card has-shadow has-hover" :class="entranceClassList">
            <a class="etx-card__link Card__link" :href="newsItem.url?.path" :title="newsItem.title"></a>
            <div class="etx-card__item Card__item ph-0 pv-0">
              <div class="etx-media Media">
                <MediaImage :media="newsItem?.image" imageStyle="image_3_2" />
              </div>
            </div>
            <div class="etx-card__item Card__item pb-0 grow-1">
              <div v-if="newsItem.tags" class="TagList" :class="entranceClassList">
                <div v-for="tag in newsItem.tags" :key="tag.name" class="Tag">
                  {{ tag.name }}
                </div>
              </div>
            </div>
            <div class="etx-card__item Card__item pt-200 pb-150 grow-1">
              <div class="etx-text Text">
                <p class="font-size-smaller font-color-medium">{{ newsItem.readingduration }}</p>
                <p class="font-size-larger">
                  <span class="font-weight-bold">{{ newsItem.title }}</span><br>
                  <span class="font-color-medium">{{ newsItem.subtitle }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts" setup>

const props = defineProps<{
  News: Array<{
    uuid: string
    title?: string
    subtitle?: string
    lead?: string
    sublead?: string
    readingduration?: string
    publication?: string
    depublication?: string
    visibledate?: Object
    tags?: Array<Object>
    location?: Array<Object>
    image?: Object
    url?: Array<Object>
  }>
}>()

const newsIds: string[] = (props.News || []).map((newsItem) => newsItem.uuid);
const queryKey = `newsItems-${newsIds.join('-')}`;
const { data: News = [] } = await useAsyncData(queryKey, async () => {
  return await useGraphqlQuery('News', { ids: newsIds }).then((v) => {
    return v.data?.entityQuery?.items ?? [];
  });
});

const { options, isEditing } = defineBlokkli({
  bundle: 'news_listing_automatically',
  globalOptions: ['spacingTop', 'spacingBottom'],
});

const paragraphClassList = computed(() => {
  const classList = [];

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop);
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom);
  }

  return classList;
});

const entranceClassList = computed(() => {
  const classList = [];
  if (!isEditing) {
    classList.push('will-appear', 'move-up');
  }
  return classList;
});
</script>